module.exports = __webpack_public_path__ + "media/assets/images/flags/ge-3fee17dfe5d4db9036a357821914cd37.svg";